/**
 * Полоса «пройдено N из M» для трека.
 *
 * Числовое значение всегда рядом в тексте карточки, а сама полоса несёт
 * `aria-valuenow`: она иллюстрация, а не единственный источник числа.
 */

export function TrackProgressBar({ solved, total }: { solved: number; total: number }) {
  const percent = total === 0 ? 0 : Math.round((solved / total) * 100)
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={solved}
      className="h-1.5 overflow-hidden rounded-full bg-border"
    >
      <div className="h-full rounded-full bg-accent" style={{ width: `${percent}%` }} />
    </div>
  )
}
